// components/GlossyBox.tsx
import { Box, BoxProps } from "@chakra-ui/react";
import React from "react";

export const GlossyBox: React.FC<BoxProps> = ({ children, ...props }) => {
  return (
    <Box
      position="relative"
      overflow="hidden"
      bg="rgba(255, 255, 255, 0.1)"
      backdropFilter="blur(12px) saturate(160%)"
      borderRadius="2xl"
      boxShadow="0 8px 32px rgba(0, 0, 0, 0.2)"
      border="1px solid"
      borderColor="rgba(255, 255, 255, 0.2)"
      _before={{
        content: '""',
        position: "absolute",
        inset: 0,
        background:
          "linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 60%)",
        zIndex: 0,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};